// React Components
import React from "react";

// Material UI Components
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';


// Function to insert our User selector (textfield).
// Later enhance to auto-complete on user name.
export default function UserSelector(props){

    const { tenantId, selectedUserId, setSelectedUserId, selectedUserIdValue, errorSelectedUserId } = props;

    return(
        
        <Grid item xs={12}>
            {/* User input field control. */}
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: '140px minmax(0, 600px)' }, gap: { xs: 1, sm: 0 }, width: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <b>For User:</b>
                </Box>
                <Box sx={{ minWidth: 0 }}>
                    <TextField                        
                        required
                        name="User Text Field"
                        id="userTextfield"
                        placeholder="Enter User Id here (firstname.lastname@company.com)."
                        variant="outlined"
                        size="small"
                        fullWidth
                        inputProps={{ maxLength: 100 }}
                        InputLabelProps={{ shrink: true }}
                        onChange={event => setSelectedUserId(event.target.value)}
                        inputRef={selectedUserIdValue}
                        value={selectedUserId}
                        error={errorSelectedUserId}
                        helperText={errorSelectedUserId ? 'User ID cannot be empty.' : ''}                     
                    />
                </Box>
            </Box>
        </Grid>
    );
};
